import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import SimpleReactValidator from 'simple-react-validator'
import { fetchCsrfCookie } from '../../../../redux/action/csrf/csrf-cookie'
import { fetchContactData } from '../../../../redux/action/homePage/homeContactUs'
import MainLoading from '../../../../utils/MainLoading'

const Contact = () => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const dispatch = useDispatch()
    const contactData = useSelector(state => state.contactData)
    const {t} = useTranslation();

    const [data, setData] = useState({
        mail: '',
        phone: '',
        zip_code: '',
        fax: '',
        address: '',
    })

    const handleNameChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است",
          min: " تعداد کاراکترهای ورودی کم است " ,
          numeric: 'تلفن باید فقط حاوی عدد باشد'
        },
    }))

    useEffect(() => {
        if(!contactData.contactData.id) {
            dispatch(fetchContactData())
        }
    }, [])

    useEffect(() => {
        setData({
            mail: contactData.contactData.mail ? contactData.contactData.mail: '' ,
            phone: contactData.contactData.phone ? contactData.contactData.phone: '',
            zip_code: contactData.contactData.zip_code ? contactData.contactData.zip_code: '',
            fax: contactData.contactData.fax ? contactData.contactData.fax: '',
            address: contactData.contactData.address ? contactData.contactData.address: ''
        })
    }, [contactData.contactData])
    

    const handleFromSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            dispatch(fetchCsrfCookie())
            axios.post('admin/contact-us', data, {withCredentials: true})
            .then(res => {
                setBtnLoading(false)
                toast.dismiss()	
                toast.success(t("toast_successfully_created") , {position: 'bottom-right',className: 'foo-bar'})
            })
            .catch(err => {
                setBtnLoading(false)
                if(err.response.data) {
                    console.log(err.response.data.errors)
                }
            })
        }
        else {
            setBtnLoading(false)
            setForceUpdate(1)
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
            validator.current.showMessages()
            window.scrollTo(0, 0)
        }
    }

    return (
        <div className='mt-5'>
            {contactData.loading ? 
                <MainLoading />
            :
                <Form className='col-lg-5' onSubmit={handleFromSubmit}>
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>{t("email")} :</Form.Label>
                        <Form.Control type="email" name="mail" value={data.mail} onChange={handleNameChange}  />
                        <span className='validator_error'>{validator.current.message('mail', data.mail, 'required|email')}</span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formPhone">
                        <Form.Label>{t("phone")} :</Form.Label>
                        <Form.Control type="text" name="phone" value={data.phone} onChange={handleNameChange} />
                        <span className='validator_error'>{validator.current.message('phone', data.phone, 'required|numeric')}</span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formzipcode">
                        <Form.Label>{t("Postal code")} :</Form.Label>
                        <Form.Control type="text" name="zip_code" value={data.zip_code} onChange={handleNameChange} />
                        <span className='validator_error'>{validator.current.message('zip_code', data.zip_code, 'required|min: 10')}</span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formFax">
                        <Form.Label>{t("fax")} :</Form.Label>
                        <Form.Control type="text" name="fax" value={data.fax} onChange={handleNameChange} />
                        <span className='validator_error'>{validator.current.message('fax', data.fax, 'required')}</span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formAddress">
                        <Form.Label>{t("address")} :</Form.Label>
                        <Form.Control as="textarea" rows={3} name="address" value={data.address} onChange={handleNameChange} />
                        <span className='validator_error'>{validator.current.message('address', data.address, 'required')}</span>
                    </Form.Group>
                    <Button variant="success" type="submit" className='px-4 mt-2' disabled={btnLoading ? true : false}>
                       {t("submit")}
                    </Button>
                </Form>
            }
        </div>
    )
}

export default Contact
